import { motion } from 'framer-motion';
import { User, Compass, FileCode2, Globe } from 'lucide-react';

const DIAGRAM_ICONS = [User, Compass, FileCode2, Globe];

const Technologies = ({ t }) => {
  return (
    <section id="tech" className="relative py-20 sm:py-24 lg:py-28" data-testid="technologies">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="kicker-mono mb-3">{t.tech.kicker}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-[650] tracking-tight text-white" data-testid="tech-title">
            {t.tech.title}
          </h2>
          <p className="mt-4 text-white/70 text-base sm:text-lg">{t.tech.subtitle}</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 mb-14" data-testid="tech-badge-grid">
          {t.tech.badges.map((b, i) => (
            <motion.span
              key={b}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.03 }}
              className="chip hover:border-[rgba(5,126,243,.6)] transition-colors"
              data-testid={`tech-badge-${i}`}
            >
              <span className="dot" />
              {b}
            </motion.span>
          ))}
        </div>

        {/* Diagram */}
        <div className="gradient-border" data-testid="tech-diagram">
          <div className="inner p-6 sm:p-8">
            <div className="kicker-mono text-white/60 mb-6">{t.tech.diagram.title}</div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-center relative">
              {t.tech.diagram.nodes.map((n, i) => {
                const Icon = DIAGRAM_ICONS[i] || User;
                return (
                  <div key={n} className="flex flex-col items-center text-center">
                    <div className="relative h-16 w-16 rounded-2xl bg-[rgba(5,126,243,.12)] border border-[rgba(5,126,243,.4)] flex items-center justify-center text-[rgb(var(--brand-electric))]">
                      <Icon size={26} />
                      <span className="absolute -top-2 -right-2 text-[10px] font-mono-accent uppercase tracking-wider bg-[rgb(var(--bg-2))] border border-white/10 text-white/70 px-1.5 py-0.5 rounded">{String(i + 1).padStart(2, '0')}</span>
                    </div>
                    <div className="mt-3 font-display text-sm font-semibold text-white">{n}</div>
                  </div>
                );
              })}
            </div>
            <div className="dashed-line mt-8" />
            <div className="mt-3 flex justify-between kicker-mono text-white/40 text-[10px]">
              <span>INPUT</span>
              <span>PROCESS</span>
              <span>CONTRACT</span>
              <span>ON-CHAIN</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technologies;
